import { Controller } from "stimulus";
import { debounce } from 'lodash';

export default class extends Controller {

  static targets = ['uploadInput', 'fileName']

  initialize() {
    this.search = debounce(this.search, 1500).bind(this)
  }

  connect() {
    const url = new URL(window.location.href);

    if (url.searchParams.has('published')) {
      $('#post-publish').modal('show');
      this.clearUrlParams(url, 'published');
    }

    $('.lj-tooltip').hover(function () {
      $(this).find('.tooltipinfo').removeClass('d-none');
    }, function () {
      $(this).find('.tooltipinfo').addClass('d-none');
    });

    $('.journey-training-action').on("click", (e) => {
      e.stopPropagation();
    });
  }

  uploadImage() {
    $(this.uploadInputTarget).click();
  }

  showFileName() {
    const filename = this.uploadInputTarget.files[0].name;

    if (filename.length > 15) {
      this.fileNameTarget.textContent = `${filename.substring(0, 10)}_.${filename.split('.').pop()}`;
    } else {
      this.fileNameTarget.textContent = filename;
    }
  }

  search(event) {
    $('#search_spinner').removeClass('d-none')
    $('#title-search').val($('#searchField').val());
    $('#apply-search').click();
  }

  clearUrlParams(url, param) {
    url.searchParams.delete(param);
    const newUrl = url.search ? url.href : url.href.replace('?', '');
    window.history.replaceState({}, document.title, newUrl);
  }

  shiftInterval(event) {
    const selectedOption = $(event.target).closest('.dropdown-item');
    const selectedText = selectedOption.find('.option-text').text();

    $('#interval-button').text(selectedText);
    $('.dropdown-item').removeClass('active');
    selectedOption.addClass('active');
  }

  handleAssign(event) {
    event.preventDefault();
    let selectedValues = $(event.target).closest('.modal').find('#learning-journeys-select option:selected').map(function () { return $(this).val(); }).get();

    if (selectedValues.length) {
      hideModalClasses();

      $('#learner-count').html($('.learners_counter').html())

      $(`#${event.target.dataset["targetModal"]}`).attr({ 'data-bs-backdrop': 'static', 'data-bs-keyboard': false });
      $(`#${event.target.dataset["targetModal"]}`).modal('show');
    } else {
      alert('Please select valid journey options')
    }
  }

  updateTrainingDueDate() {
    var dueDays = event.currentTarget.dataset.value
    var journeyTrainingId = event.currentTarget.dataset.trainingId
    var companyId = this.element.dataset.companyId

    var requestData = `id=${journeyTrainingId}&journey_training[due_days]=${dueDays}`

    Rails.ajax({
      url: `/companies/${companyId}/journey_trainings`,
      dataType: 'script',
      type: 'patch',
      data: requestData
    })
  }
}
